<template>
  <v-card>

    <!-- Export Excel : bouton simple sans filtre, menu à 2 choix quand un filtre est actif -->
    <div class="d-flex justify-end pt-3 pr-6">
      <v-btn v-if="!hasActiveFilters" color="primary" small outlined @click="exportExcel(false)">
        <v-icon left small>mdi-download</v-icon>
        Export Excel
      </v-btn>

      <v-menu v-else offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" color="primary" small outlined>
            <v-icon left small>mdi-download</v-icon>
            Export Excel
            <v-icon small right>mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item @click="exportExcel(true)">
            <v-list-item-icon class="mr-2">
              <v-icon small>mdi-filter-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Bornes filtrées ({{ filteredKiosks.length }})</v-list-item-title>
          </v-list-item>
          <v-list-item @click="exportExcel(false)">
            <v-list-item-icon class="mr-2">
              <v-icon small>mdi-database-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Toutes les bornes ({{ (store.state.listOfKiosks || []).length }})</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

    <v-card-title>
      <v-chip-group v-model="selectedTags" multiple column class="mx-2" style="max-width: 60%;">
        <v-chip v-for="tag in filterableTags" :key="tag.name" :value="tag.name" filter outlined small class="ma-1"
          :color="tag.color">
          {{ tag.name }}
        </v-chip>
      </v-chip-group>

      <v-btn-toggle v-model="tagFilterMode" mandatory dense class="ml-2" :disabled="selectedTags.length < 2">
        <v-btn value="OU">OU</v-btn>
        <v-btn value="ET">ET</v-btn>
      </v-btn-toggle>

      <v-spacer>
      </v-spacer>

      <v-select v-model="searchField" :items="searchFields" item-text="text" item-value="value" label="Rechercher dans"
        hide-details style="max-width: 200px; margin-right: 1rem;"></v-select>

      <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details
        clearable></v-text-field>
    </v-card-title>

    <KioskFilterBar v-model="facetFilters" :options="facetOptions">
      <template v-slot:actions>
        <v-btn v-if="hasActiveFilters" small outlined class="mr-2 mb-1"
          :color="allFilteredSelected ? 'warning' : 'success'"
          @click="toggleSelectAllFiltered">
          <v-icon left small>
            {{ allFilteredSelected ? 'mdi-checkbox-multiple-blank-outline' : 'mdi-checkbox-multiple-marked' }}
          </v-icon>
          {{ allFilteredSelected ? 'Tout désélectionner' : 'Tout sélectionner' }} ({{ filteredKiosks.length }})
        </v-btn>
      </template>
    </KioskFilterBar>

    <v-data-table fixed-header v-model="selected" :headers="headers" :items="filteredKiosks" item-key="name"
      class="elevation-1">

      <template v-slot:[`item.selected`]="{ item }">
        <v-chip text-color="white">
          {{ item }}</v-chip>
      </template>
      <template style="pointer-events : none;" v-slot:[`item.lastCheck`]="{ item }" width="100%">
        <v-chip text-color="white" :color="getColor(item.lastCheck.lastCheck)" width="100%">
          {{ item.lastCheck.toPrint }}
        </v-chip>

      </template>

      <template v-slot:[`item.tags`]="{ item }">
        <v-chip class="ma-1 white--text" :style="{ background: tags[n.id].color }" v-for="(n, key) in item.tags"
          :key="key">
          {{ n.name }}
        </v-chip>
      </template>
      <template v-slot:[`item.name`]="{ item }">
        <td class="name-cell">
          <span class="clickable-name" @click="handleClick(item)" @mouseenter="maybeAddOnShift(item, $event)">{{
            item.name }}</span>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon small v-bind="attrs" v-on="on" @click.stop="handleButtonHistoryClick(item)"><v-icon
                  small>mdi-history</v-icon></v-btn>
            </template>
            <span>Historique des versions</span>
          </v-tooltip>
        </td>
        <!--<td text-color="white" @click="handleClick(item)">{{ item.name }} </td>-->
      </template>

      <!-- <template v-slot:[`item.etat`]="{ item }"  >
    <v-chip   text-color="white" @click.stop="updateEtat(item)" :color="VerifyEtat(item)">{{ item.etat}}</v-chip>      
  </template> -->

      <template v-slot:[`item.isSelected`]="{ item }">
        <v-checkbox :input-value=item.isSelected @click="toggleSelection(item)" class="custom-checkbox"></v-checkbox>
      </template>
      <template v-slot:[`item.lastJob`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon :class="{ 'spin': LastJobColor[item.lastJob] === 'grey' }" :color="LastJobColor[item.lastJob]"
              v-on="on" :value="LastJobIcon[item.lastJob] || LastJobIcon['Default']">{{ LastJobIcon[item.lastJob] ||
                LastJobIcon['Default'] }}</v-icon>
          </template>
          <span>{{ item.lastJob || 'Loading' }}</span>
        </v-tooltip>
      </template>

      <template v-slot:[`item.state`]="{ item }">
        <v-chip :color="LastJobColor[item.state]" text-color="white">{{ item.state }}</v-chip>
      </template>

      <template v-slot:[`item.jobDtae`]="{ item }">
        <div>{{ item.jobDtae || 'Loading' }}</div>
      </template>

      <template v-slot:[`item.sleepActive`]="{ item }">
        <v-tooltip v-if="item.sleepActive === false" bottom>
          <template v-slot:activator="{ on }" v-if="item.sleepActive === false">
            <v-icon :color="LastJobColor['warning']" v-on="on">{{ LastJobIcon['warning'] }}</v-icon>
          </template>
          <span>The terminal has not been put on standby for over 48 hours</span>
        </v-tooltip>
      </template>



    </v-data-table>

    <v-dialog v-model="showHistory" max-width="600px">
      <v-card v-if="currentItem">
        <v-card-title>
          Historique des versions : {{ currentItem.name }}
        </v-card-title>

        <v-divider />

        <v-card-text>
          <!-- Ici on remplace les colonnes v-list par une simple table -->
          <v-simple-table>
            <thead>
              <tr>
                <th class="text-left">Version</th>
                <th class="text-left">Date</th>
                <th class="text-left">Fait par</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in dialogHistory" :key="item.id">
                <td>{{ item.version }}</td>
                <td>{{ item.date }}</td>
                <td>{{ item.user }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="showHistory = false">Fermer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div>
      <!-- <DialogComponent :show="showDialog"  :item="objet" v-if="showDialog == true " @closeDialogConfirmation="closeDialogConfirmation()"></DialogComponent> -->

    </div>
  </v-card>
</template>
<script>


import { niceDateTimeFormat } from "@/utils/DateFormatter";
import { store } from "@/models/Store.js";
import KioskFilterBar from "./KioskFilterBar.vue";
import * as XLSX from "xlsx";
//import { getListLastJobs } from "@/services/RequestService";
//import  DialogComponent  from './DialogConfirmationComponent.vue';

export default {
  components: { KioskFilterBar },
  async beforeCreate() {
    store.firstCallAndLaunchIntervals();
  },
  mounted() {

    // �couter un element'custom-event'
    this.$on('custom-event', () => {
      this.showDialog = false;
      // Mettre � jour les �l�ments de la liste afficher
      if (store.state.afficher.length !== 0) {
        this.selected = store.state.afficher;
        store.setAfficher([]);
      }


      // let list = []
      // for (const element of this.kiosksTableData) {
      //   list.push(element.name)
      // }
      // try {
      //   getListLastJobs(list).then((e) => {
      //     store.setJobs(e)
      //   })
      // }
      // catch (e) {
      //   console.log(e);
      // }
      try {
        store.firstCallAndLaunchIntervals();
      }
      catch (e) {
        console.log(e);
      }
    });

    // Add listeners for Shift-hover highlighting
    window.addEventListener("keydown", this._onKeyDown);
    window.addEventListener("keyup", this._onKeyUp);
    const tableEl = this.$el && this.$el.querySelector('.v-data-table');
    if (tableEl) {
      tableEl.addEventListener('mousemove', this._onTableMouseMove);
      tableEl.addEventListener('mouseleave', this._clearShiftHover);
    }

  },

  beforeDestroy() {
    window.removeEventListener("keydown", this._onKeyDown);
    window.removeEventListener("keyup", this._onKeyUp);
    const tableEl = this.$el && this.$el.querySelector('.v-data-table');
    if (tableEl) {
      tableEl.removeEventListener('mousemove', this._onTableMouseMove);
      tableEl.removeEventListener('mouseleave', this._clearShiftHover);
    }
  },


  data() {
    return {
      // Object to define the color for each job status
      LastJobColor: {
        created: "orange",
        transmited: "green",
        done: "blue",
        abandonned: "red",
        AppUpdateJob: "primary",
        NoSleepJob: "primary",
        GetReportJob: "primary",
        GetDiagJob: "primary",
        GetSetParamJob: "primary",
        GetSetPropertiesJob: "primary",
        DebugJob: "primary",
        WeRepairJob: "primary",
        KillJavaJob: "primary",
        ResetNameJob: "primary ",
        null: "grey",
        SetOrGetParamJob: "primary ",
        'Not found': "black",
        warning: "orange"

      },        // lignes sélectionnées
      isShiftSelecting: false,
      searchField: 'all',
      searchFields: [
        { text: 'Tous les champs', value: 'all' },
        { text: 'KioskExtranetId', value: 'idExtranet' },
        { text: 'Kiosk', value: 'name' },
        { text: 'softwareVersion', value: 'softwareVersion' },
        { text: 'VPN', value: 'vpnAddress' },
        { text: 'LastJob', value: 'lastJob' },
        { text: 'StateLastJob', value: 'state' },
        { text: 'DateLastJob', value: 'jobDtae' },
      ],
      // whether Shift is currently held (used for hover behavior)
      shiftPressed: false,
      // index of hovered row inside current tbody when Shift is held
      shiftHoveredRowIndex: null,
      objet: {},
      showDialog: false,
      sortDescending: true,
      afficher: [],
      store: store,
      showHistory: false,
      currentItem: null,
      dialogHistory: [
        { id: 1, version: 'TEST', date: '2026-01-15', user: 'Nuage' },
        { id: 2, version: 'TEST', date: '2025-12-10', user: 'Autres' },
        { id: 3, version: 'TEST', date: '2025-11-05', user: 'Nuage' },
        { id: 4, version: 'TEST', date: '2025-10-01', user: 'Nuage' }
      ],
      /**
       * The list of tags in the Tag selection field.
       */
      tagsList: store.tagsList,
      // currently selected tag in the Tag selection field
      selectedTags: [],
      search: "",
      tagFilterMode: 'OU',
      // Barre de facettes (les facettes se cumulent en ET)
      facetFilters: {
        versions: [],
        jobTypes: [],
        states: [],
        jobDate: null,
        lastPing: null,
        warning: null
      },
      /**
       * It's the trigger for activate 
       * computed => kiosksTableData when selecttag change
       */
      triggerTagChangement: 0,
      selected: [],
      headers: [
        { text: '', value: 'isSelected', sortable: true, },
        {
          text: "KioskExtranetId",
          align: "start",
          sortable: true,
          value: "idExtranet",
        },
        {
          text: "Kiosk",
          align: "start",
          sortable: true,
          value: "name",
        },
        { text: "Tags", value: "tags", align: "center" },
        // { text: "Installed", value: "etat", align: "center" },
        {
          text: "Status", value: "lastCheck", align: "center",
          sort: (a, b) => {

            let timeA = new Date(a.lastCheck).getTime();
            let timeB = new Date(b.lastCheck).getTime();
            if (a.lastCheck === undefined || b.lastCheck === undefined) {
              if (a.lastCheck === undefined && b.lastCheck === undefined) {
                return 0;
              } else if (a.lastCheck === undefined) {
                return -1;
              } else {
                return 1;
              }
            } else {
              let diff = timeA - timeB
              if (diff < 0) {
                return - 1
              } else if (diff > 0) {
                return 1;
              } else {
                return 0;
              }
            }
          }

        },
        //  { text: "mac", value: "macAddress" },
        { text: "softwareVersion", value: "softwareVersion", align: "center" },
        { text: "VPN", value: "vpnAddress", align: "center" },
        { text: "LastJob", value: "lastJob", align: "center", sortable: true },
        { text: "StateLastJob", value: "state", align: "center", sortable: true },
        {
          text: "DateLastJob", value: "jobDtae", align: "center", sortable: true, sort: function (a, b) {

            if (a === "Not found") {
              return this.sortDescending ? 1 : -1; // placer les cha�nes "not found" en dernier
            } else if (b === "Not found") {
              return this.sortDescending ? -1 : 1;
            } else {
              const regex = /(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})/;
              const aMatch = a.match(regex);
              const bMatch = b.match(regex);
              const aDate = new Date(
                aMatch[3],
                aMatch[2] - 1,
                aMatch[1],
                aMatch[4],
                aMatch[5],
                aMatch[6]
              );
              const bDate = new Date(
                bMatch[3],
                bMatch[2] - 1,
                bMatch[1],
                bMatch[4],
                bMatch[5],
                bMatch[6]
              );
              if (aDate > bDate) {
                return this.sortDescending ? -1 : 1;
              } else if (aDate < bDate) {
                return this.sortDescending ? 1 : -1;
              } else {
                return 0;
              }
            }
          }
        },
        { text: "Warning", value: "sleepActive", align: "center", sortable: true }

      ],
      kiosks: [],

    };
  },
  watch: {
    selected() {
      store.setSelectedKiosks(this.selected);
    },
    searchField() {
      // force Vuetify à relancer le custom-filter
      const s = this.search;
      this.search = s ? s + ' ' : ' ';
      this.$nextTick(() => { this.search = s; });
    },
  },
  methods: {

    // Add or remove item from selection when hovering the name while Shift is held
    maybeAddOnShift(item, event) {
      if (!(this.shiftPressed || (event && event.shiftKey))) {
        return;
      }

      const exists = this.selected.find((s) => s.name === item.name);
      if (exists) {
        // remove
        this.selected = this.selected.filter((s) => s.name !== item.name);
        store.setSelectedKiosks(this.selected);
      } else {
        // add
        this.selected.push(item);
        store.setSelectedKiosks(this.selected);
      }
    },

    // Handlers for Shift-hover highlighting
    _onKeyDown(e) {
      if (e.key === 'Shift') {
        this.shiftPressed = true;
      }
    },
    _onKeyUp(e) {
      if (e.key === 'Shift') {
        this.shiftPressed = false;
        this._clearShiftHover();
      }
    },
    _onTableMouseMove(event) {
      if (!this.shiftPressed) {
        this._clearShiftHover();
        return;
      }

      const tr = event.target.closest('tr');
      if (!tr || tr.parentElement.tagName !== 'TBODY') {
        this._clearShiftHover();
        return;
      }

      const rows = Array.from(tr.parentElement.children);
      const idx = rows.indexOf(tr);
      if (idx === -1) {
        this._clearShiftHover();
        return;
      }

      if (this.shiftHoveredRowIndex === idx) return;

      // remove previous
      if (this.shiftHoveredRowIndex !== null) {
        const prev = tr.parentElement.children[this.shiftHoveredRowIndex];
        if (prev) prev.classList.remove('nuage-shift-hover');
      }

      // add to current
      const newRow = rows[idx];
      if (newRow) newRow.classList.add('nuage-shift-hover');
      this.shiftHoveredRowIndex = idx;
    },
    _clearShiftHover() {
      const tableEl = this.$el && this.$el.querySelector('.v-data-table');
      if (!tableEl) return;
      const tbody = tableEl.querySelector('tbody');
      if (!tbody) return;
      if (this.shiftHoveredRowIndex !== null) {
        const prev = tbody.children[this.shiftHoveredRowIndex];
        if (prev) prev.classList.remove('nuage-shift-hover');
      }
      this.shiftHoveredRowIndex = null;
    },

    //chekbox
    toggleSelection(item) {
      //delete item if exist in Selcted
      const foundElement = this.selected.find((objet) => objet.name === item.name);
      if (foundElement) {
        this.selected = this.selected.filter((value) => {
          return value.name !== item.name;
        });
        store.setSelectedKiosks(this.selected);
      }
      //add item
      else {
        this.selected.push(item);
        store.setSelectedKiosks(this.selected);
      }
    },

    //click on the kiosk name 
    handleClick(item) {

      this.afficher = []
      //to keep the elements of my list selected after clicking on close => copy selected list 
      if (this.selected.length > 0) {
        for (var i in this.selected) {
          this.afficher.push(this.selected[i]);
        }
        store.setAfficher(this.afficher);
        this.selected = [];
        // set active row and deselect others
        store.setSelectedKiosks(this.selected)
      }
      this.selected.push(item);
      store.setSelectedKiosks(this.selected);
      this.chClick();
    },

    handleButtonHistoryClick(item) {
      this.currentItem = item
      this.showHistory = true
    },
    //Get Color Of buton yes / No
    // check if the machine is installed

    VerifyEtat(item) {
      let color = "green";
      if (item.etat === "no" || item.etat === "NO") {
        color = "red";
      }
      else {
        //initialize state 
        item.etat = "yes";
      }
      this.dialogVisible = true;
      return color;
    },
    //Open the dialogConfirmation
    async updateEtat(item) {
      if (this.showDialog == true) {
        this.showDialog = false;
      }
      this.objet = item;
      this.showDialog = true;
    },
    chClick() {
      //showBottomSheet
      this.$emit("sh");
    },
    /**
       * Increment a number for trigger computed
       * when we change the selectedTag
       */
    onChangeSelectTag() {
      this.triggerTagChangement += 1;
    },
    /**
     * Export Excel des bornes.
     * @param {boolean} onlyFiltered - true : la vue filtrée ; false : tout le parc
     */
    exportExcel(onlyFiltered) {
      const rows = onlyFiltered
        ? this.filteredKiosks.map((item) => this.exportRowFromItem(item))
        : (this.store.state.listOfKiosks || []).map((k) => this.exportRowFromRawKiosk(k));

      if (rows.length === 0) return;

      const worksheet = XLSX.utils.json_to_sheet(rows);
      worksheet['!cols'] = Object.keys(rows[0]).map((header) => ({
        wch: Math.max(header.length + 2, 18)
      }));

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Kiosks');

      const date = new Date().toISOString().substring(0, 10);
      XLSX.writeFile(workbook, (onlyFiltered ? 'kiosks_filtres_' : 'kiosks_') + date + '.xlsx');
    },

    // ligne d'export depuis un item déjà mappé pour la table (vue filtrée)
    exportRowFromItem(item) {
      return {
        'KioskExtranetId': item.idExtranet,
        'Kiosk': item.name,
        'Tags': item.tags ? item.tags.map((t) => t.name).join(', ') : '',
        'Dernier ping': item.lastCheck && item.lastCheck.toPrint ? item.lastCheck.toPrint : '',
        'Version': item.softwareVersion,
        'VPN': item.vpnAddress,
        'Dernier job': item.lastJob,
        'État du job': item.state,
        'Date du job': item.jobDtae
      };
    },

    // ligne d'export depuis un document kiosk brut (export complet, hors filtres)
    exportRowFromRawKiosk(k) {
      const entry = this.store.state.kiosksWithTags[k.idExtranet];
      return {
        'KioskExtranetId': k.idExtranet,
        'Kiosk': k.name,
        'Tags': entry && entry.tags ? entry.tags.map((t) => t.name).join(', ') : '',
        'Dernier ping': this.formatDate(k.lastCheck) || '',
        'Version': k.softwareVersion,
        'VPN': k.vpnAddress,
        'Dernier job': k.typeLastJob || 'Not found',
        'État du job': k.stateLastJob || 'Not found',
        'Date du job': this.formatDate(k.dateLastJob) || 'Not found'
      };
    },

    /**
     * Ajoute toutes les bornes filtrées à la sélection globale,
     * ou les en retire si elles y sont déjà toutes.
     * La sélection existante (hors filtre) est préservée dans les deux sens.
     */
    toggleSelectAllFiltered() {
      if (this.allFilteredSelected) {
        // retirer les bornes filtrées de la sélection
        const filteredNames = new Set(this.filteredKiosks.map((k) => k.name));
        this.selected = this.selected.filter((s) => !filteredNames.has(s.name));
      } else {
        // ajouter les bornes filtrées manquantes (sans dupliquer)
        const selectedNames = new Set(this.selected.map((s) => s.name));
        const toAdd = this.filteredKiosks.filter((k) => !selectedNames.has(k.name));
        this.selected = [...this.selected, ...toAdd];
      }
      // le watch sur `selected` synchronise le store (setSelectedKiosks)
    },

    /**
     * Applique les facettes de la barre de filtres (cumul en ET).
     */
    matchesFacetFilters(item) {
      const ff = this.facetFilters;

      if (ff.versions.length > 0 && !ff.versions.includes(item.softwareVersion)) return false;
      if (ff.jobTypes.length > 0 && !ff.jobTypes.includes(item.lastJob)) return false;
      if (ff.states.length > 0 && !ff.states.includes(item.state)) return false;

      // warning veille : l'icône s'affiche quand sleepActive === false
      if (ff.warning === 'shown' && item.sleepActive !== false) return false;
      if (ff.warning === 'hidden' && item.sleepActive === false) return false;

      if (ff.jobDate && !this.matchDaysFilter(this.parseJobDate(item.jobDtae), ff.jobDate)) return false;
      if (ff.lastPing && !this.matchDaysFilter(item.lastCheck ? item.lastCheck.lastCheck : null, ff.lastPing)) return false;

      return true;
    },

    /**
     * Filtre "en jours" : sel = {mode: 'within'|'older', days}.
     * 'within' = date dans les N derniers jours ; 'older' = plus ancienne.
     * Sans date valide (ex : "Not found") => exclu.
     */
    matchDaysFilter(date, sel) {
      if (date == null) return false;
      const time = new Date(date).getTime();
      if (isNaN(time)) return false;
      const limit = Date.now() - sel.days * 24 * 60 * 60 * 1000;
      return sel.mode === 'within' ? time >= limit : time < limit;
    },

    /**
     * jobDtae est une chaîne formatée "JJ/MM/AAAA HH:MM:SS" (ou "Not found")
     */
    parseJobDate(jobDtae) {
      if (!jobDtae || jobDtae === 'Not found') return null;
      const m = String(jobDtae).match(/(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})/);
      if (!m) return null;
      return new Date(m[3], m[2] - 1, m[1], m[4], m[5], m[6]);
    },

    matchesSearch(item) {
      if (!this.search) return true;               // pas de recherche => tout garder
      const search = this.search.toLowerCase().trim();

      // Recherche ciblée sur un seul champ
      if (this.searchField && this.searchField !== 'all') {
        let v = item[this.searchField];
        if (v == null) return false;

        // id : correspondance EXACTE (taper "2" ne doit pas matcher "22")
        if (this.searchField === 'idExtranet') {
          return v.toString().toLowerCase().trim() === search;
        }
        if (typeof v === 'object' && v.toPrint !== undefined) v = v.toPrint;
        if (Array.isArray(v)) {
          return v.some((it) =>
            Object.values(it).some((x) => x && x.toString().toLowerCase().includes(search))
          );
        }
        return v.toString().toLowerCase().includes(search);
      }

      // Recherche globale
      return Object.values(item).some((v) => {
        if (v && v.toString().toLowerCase().includes(search)) return true;
        if (v && v.toPrint !== undefined && v.toPrint.toString().toLowerCase().includes(search)) return true;
        return false;
      });
    },
    getColor(item) {
      if (item == undefined) {
        return "grey";
      }
      if (this.isDateMoreThanTwoDaysFromNow(item)) {
        return "red";
      } else if (this.isDateMoreThanOneDayFromNow(item)) {
        return "orange";
      } else {
        return "green";
      }
    },

    isDateMoreThanNdaysFromNow(inDate, nDays) {
      let dateInMillis = new Date(inDate).getTime();
      let now = Date.now();
      let oneDayInMillis = 24 * 60 * 60 * 1000;
      return now - dateInMillis > oneDayInMillis * nDays;
    },
    isDateMoreThanOneDayFromNow(inDate) {
      return this.isDateMoreThanNdaysFromNow(inDate, 1);
    },

    isDateMoreThanTwoDaysFromNow(inDate) {
      return this.isDateMoreThanNdaysFromNow(inDate, 2);
    },
    formatDate: function (date) {
      if (date === undefined) {
        return;
      } else {
        return niceDateTimeFormat(new Date(date));
      }
    },
    determineEndIndexToStudyWithNRollingDays(array, N) {
      let indToReturn = -1;
      for (let j = 0; j < array.length; j++) {
        if (this.isDateMoreThanNdaysFromNow(array[j].updatedAt, N)) {
          break;
        }
        indToReturn = j;
      }
      return indToReturn;
    },
    findJobByKioskName(name) {
      const jobs = this.store.state.jobs;
      if (jobs) {
        const job = jobs.find(job => job.kiosk === name)?.job;
        return job || null;
      }
      return null;
    },
    findAutoDiagJobByKioskName(date) {
      const twoDaysAgo = new Date();
      twoDaysAgo.setUTCDate(twoDaysAgo.getUTCDate() - 2); // Utiliser setUTCDate pour soustraire deux jours en UTC
      if (date != undefined) {
        const dateLastAutoDiagJob = new Date(date);
        return dateLastAutoDiagJob >= twoDaysAgo;
      }
      return false;
    }
  },
  computed: {
    /**
    * Tags disponibles pour le filtre, avec leur couleur
    * (state.tags est rempli par setTags avec assignColorToTag)
    */
    filterableTags() {
      return Object.values(this.store.state.tags);
    },
    filteredKiosks() {
      return this.kiosksTableData.filter(
        (item) => this.matchesSearch(item) && this.matchesFacetFilters(item)
      );
    },
    /**
     * Valeurs distinctes du parc pour alimenter les facettes
     * (calculées sur la liste complète, pas la liste filtrée)
     */
    facetOptions() {
      const kiosks = this.store.state.listOfKiosks || [];
      const distinct = (values) =>
        [...new Set(values.filter((v) => v !== undefined && v !== null && v !== ''))].sort();
      return {
        versions: distinct(kiosks.map((k) => k.softwareVersion)),
        jobTypes: distinct(kiosks.map((k) => k.typeLastJob || 'Not found')),
        states: distinct(kiosks.map((k) => k.stateLastJob || 'Not found'))
      };
    },
    /**
     * Au moins un filtre actif (tags, recherche ou facettes)
     * => le bouton "tout sélectionner" a un sens
     */
    hasActiveFilters() {
      const ff = this.facetFilters;
      return this.selectedTags.length > 0
        || (this.search != null && this.search !== '')
        || ff.versions.length > 0 || ff.jobTypes.length > 0 || ff.states.length > 0
        || ff.jobDate !== null || ff.lastPing !== null || ff.warning !== null;
    },
    /**
     * Toutes les bornes actuellement filtrées sont-elles déjà dans la sélection ?
     */
    allFilteredSelected() {
      if (this.filteredKiosks.length === 0) return false;
      const selectedNames = new Set(this.selected.map((s) => s.name));
      return this.filteredKiosks.every((k) => selectedNames.has(k.name));
    },

    /**
      * KiosksTableData receives and returns the 
      * kiosks list (with Object type) for display it 
      */
    kiosksTableData() {

      this.triggerTagChangement // Here for trigger computed when we change the selectedTag

      if (this.selectedTags.length === 0) { // If there is a tag selected, we reduct the list of DISPLAYED kiosks, we don't change the request

        return this.store.state.listOfKiosks.map((e) => {
          //for the last Job :
          const state = e ? e.stateLastJob : "Not found";
          const jobDate = e ? this.formatDate(e.dateLastJob) : "Not found";
          const lastJob = e ? e.typeLastJob : "Not found";
          const autoDiagJob = this.findAutoDiagJobByKioskName(e.dateLastAutoDiagJob);
          const sleepActive = autoDiagJob;

          for (const element of this.selected) {
            if (element.name == e.name) {
              return {
                id: e._id,
                idExtranet: e.idExtranet,
                macAddr: e.macAddress,
                name: e.name,
                etat: e.etat,
                vpnAddress: e.vpnAddress,
                softwareVersion: e.softwareVersion,
                isSelected: true,
                lastCheck: {
                  lastCheck: e.lastCheck,
                  toPrint: this.formatDate(e.lastCheck),
                },
                //jobs:this.store.state.jobs.find(job => job.kiosk === e.name),
                state: state,
                jobDtae: jobDate,
                lastJob: lastJob,
                sleepActive: sleepActive,
                tags:
                  this.store.state.kiosksWithTags[e.idExtranet] !== undefined
                    ? store.state.kiosksWithTags[e.idExtranet].tags
                    : null,
                versionWeCommon: e.versionWeCommon
              };
            }
          }

          return {
            id: e._id,
            idExtranet: e.idExtranet,
            macAddr: e.macAddress,
            name: e.name,
            etat: e.etat,
            vpnAddress: e.vpnAddress,
            softwareVersion: e.softwareVersion,
            isSelected: false,
            lastCheck: {
              lastCheck: e.lastCheck,
              toPrint: this.formatDate(e.lastCheck),
            },

            //jobs:this.store.state.jobs.find(job => job.kiosk === e.name),
            state: state,
            jobDtae: jobDate,
            lastJob: lastJob,
            //autoDiagJob: null,
            sleepActive: sleepActive,
            tags:
              this.store.state.kiosksWithTags[e.idExtranet] !== undefined
                ? store.state.kiosksWithTags[e.idExtranet].tags
                : null,
            versionWeCommon: e.versionWeCommon
          };
        });
      } else {
        let tmpList = this.store.state.listOfKiosks.filter((kiosk) => {
          const entry = this.store.state.kiosksWithTags[kiosk.idExtranet];
          if (!entry || !entry.tags) return false;
          // OU : la borne est gardée si elle porte AU MOINS UN des tags sélectionnés
          return this.tagFilterMode === 'ET'
            ? this.selectedTags.every(name => entry.tags.some(t => t.name === name))
            : entry.tags.some(t => this.selectedTags.includes(t.name));
        });
        return tmpList.map((e) => {
          //for the lastJob
          const state = e ? e.stateLastJob : "Not found";
          const jobDate = e ? this.formatDate(e.dateLastJob) : "Not found";
          const lastJob = e ? e.typeLastJob : "Not found";
          const autoDiagJob = this.findAutoDiagJobByKioskName(e.dateLastAutoDiagJob);
          const sleepActive = autoDiagJob;
          //const updatedAt = autoDiagJob === true ? "The terminal has not been put on standby for over 48 hours":"Not found"  ;
          for (const element of this.selected) {
            if (element.name == e.name) {
              return {
                id: e._id,
                idExtranet: e.idExtranet,
                macAddr: e.macAddress,
                name: e.name,
                etat: e.etat,
                vpnAddress: e.vpnAddress,
                softwareVersion: e.softwareVersion,
                isSelected: true,
                lastCheck: {
                  lastCheck: e.lastCheck,
                  toPrint: this.formatDate(e.lastCheck),
                },
                tags: store.state.kiosksWithTags[e.idExtranet].tags,
                versionWeCommon: e.versionWeCommon,
                //jobs:this.store.state.jobs.find(job => job.kiosk === e.name),
                state: state,
                jobDtae: jobDate,
                sleepActive: sleepActive,
                lastJob: lastJob,
              };
            }
          }

          return {
            id: e._id,
            idExtranet: e.idExtranet,
            macAddr: e.macAddress,
            name: e.name,
            etat: e.etat,
            vpnAddress: e.vpnAddress,
            softwareVersion: e.softwareVersion,
            isSelected: false,
            lastCheck: {
              lastCheck: e.lastCheck,
              toPrint: this.formatDate(e.lastCheck),
            },
            tags: store.state.kiosksWithTags[e.idExtranet].tags,
            versionWeCommon: e.versionWeCommon,
            //jobs:this.store.state.jobs.find(job => job.kiosk === e.name),
            state: state,
            jobDtae: jobDate,
            lastJob: lastJob,
            sleepActive: sleepActive,
          };
        });
      }
    }


    ,
    tags() {
      return this.store.state.tags;
    },
    LastJobIcon() {
      return {
        AppUpdateJob: "mdi-cellphone-arrow-down",
        NoSleepJob: "mdi-alarm-snooze",
        GetReportJob: "mdi-book-open-variant",
        GetDiagJob: "mdi-home-analytics",
        GetSetParamJob: "mdi-table-cog",
        GetSetPropertiesJob: "mdi-bottle-tonic",
        DebugJob: "mdi-cloud-braces",
        WeRepairJob: "mdi-cloud-lock-outline",
        KillJavaJob: "mdi-language-java",
        ResetNameJob: "mdi-cog-counterclockwise ",
        Default: "mdi-cog",
        'Not found': "mdi-alert-octagon",
        SetOrGetParamJob: "mdi-table-cog",
        shutDown: "mdi-power",
        warning: "mdi-alert"
      }
    },


  },
};
</script>
<style>
.v-card-title.headline {
  text-align: center;
}

.v-card-actions.justify-center {
  justify-content: center;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.spin {
  animation: spin 1s linear infinite;
}

.clickable-name {
  cursor: pointer;
  color: #000;
  margin-right: 8px;
}

.name-cell {
  display: flex;
  align-items: center;
  gap: 14px;
}

.nuage-shift-hover {
  background-color: rgba(33, 150, 243, 0.12) !important;
}
</style>